export const AUTH_TOKEN = 'auth-token'
export const CURR_NUMSCHI = 'numschi'
export const IS_ADMIN = 'isAdmin'
export const IS_LOGIN = 'isLogin'
export const MAPAPIKEY ='AIzaSyB-9jA0aB8p_ukgwZTll6slBnnKt-9-82k'
export const PREZZI = { RICOs_a: 15, RICOs_b: 10, LEO_a: 27, LEO_b: 17, BRUN_a: 33, BRUN_b: 15, DISH: 20, BOOK: 15 };